import { FactorKey } from "types/factor/factor";

import { FactorKeyCopyMap } from "../types/copy";

const APP_GOOGLE_DESCRIPTION = "Get a code from the Google Authenticator app.";
const APP_OKTA_DESCRIPTION = "Grab a code from the Okta Verify app.";

export const MFA_FACTOR_COPY: FactorKeyCopyMap = {
  [FactorKey.GoogleAuth]: {
    title: "Google Authenticator",
    activeDescription: APP_GOOGLE_DESCRIPTION,
    inactiveDescription: APP_GOOGLE_DESCRIPTION,
    setUpHeading: "Set up Google Authenticator",
    setUpDetails: (
      <>
        After downloading{" "}
        <a
          href="https://support.google.com/accounts/answer/1066447"
          target="_blank"
          rel="noopener noreferrer"
        >
          Google Authenticator
        </a>
        , open the app and scan this QR code.
      </>
    ),
    authCodeMessage: "This is the code generated by Google Authenticator.",
  },
  [FactorKey.OktaVerify]: {
    title: "Okta Verify",
    activeDescription: APP_OKTA_DESCRIPTION,
    inactiveDescription: APP_OKTA_DESCRIPTION,
    setUpHeading: "Set up your Okta Verify app",
    setUpDetails: (
      <>
        First download Okta Verify for{" "}
        <a
          href="https://help.okta.com/eu/en-us/Content/Topics/end-user/ov-setup-ios.htm"
          target="_blank"
          rel="noopener noreferrer"
        >
          iOS
        </a>{" "}
        or{" "}
        <a
          href="https://help.okta.com/eu/en-us/Content/Topics/end-user/ov-new-install-qr-android.htm"
          target="_blank"
          rel="noopener noreferrer"
        >
          Android
        </a>
        . Next, open the app and scan this QR code.
      </>
    ),
    authCodeMessage: "This is the code generated by the Okta Verify app.",
  },
  [FactorKey.Sms]: {
    title: "Phone-SMS",
    activeDescription: (phoneNumber) =>
      `We'll text you at ${phoneNumber} with a code.`,
    inactiveDescription: "We'll text you a code.",
    setUpHeading: "Set up your text message delivery",
    setUpDetails: (
      <>
        Justworks will only use this number for account security. Message and
        data rates may apply. Users in Ireland, Philippines, Singapore, and UAE
        cannot use "SMS" or "Voice call" authentication methods.
      </>
    ),
    authCodeMessage: "Check your text messages to find this code.",
  },
  [FactorKey.Call]: {
    title: "Phone-Voice call",
    activeDescription: (phoneNumber) =>
      `We’ll call you at ${phoneNumber} with a code.`,
    inactiveDescription: "We’ll call you with a code.",
    setUpHeading: "Set up your voice call delivery",
    setUpDetails: (
      <>
        Justworks will only use this number for account security. Users in
        Ireland, Philippines, Singapore, and UAE cannot use "SMS" or "Voice
        call" authentication methods.
      </>
    ),
    authCodeMessage: "Enter the code sent via voice call.",
  },
  [FactorKey.WebAuthn]: {
    title: "Security Key or Biometric Authenticator",
    activeDescription:
      "Sign in using your device’s built-in biometrics (Face ID, Touch ID, or Windows Hello).",
    inactiveDescription:
      "Sign in using your device’s built-in biometrics (Face ID, Touch ID, or Windows Hello).",
    setUpHeading: "Set up a security key or biometric authenticator",
    setUpDetails: (
      <>
        Use your device&apos;s built-in security such as Face ID, Touch ID, or
        Windows Hello to verify your identity. No codes to type.
      </>
    ),
    authCodeMessage: "",
  },
};

export const QR_KEY_CODE_LINK_COPY = "Can't scan this QR code?";
export const QR_KEY_CODE_INSTRUCTION_COPY =
  "Input this verification code manually.";

export const SECURE_BADGE_COPY = "MORE SECURE";
